/**
 * DeletableEdge - Edge customizado com botão de deletar
 *
 * Exibe um botão "X" no centro da conexão para permitir
 * que o usuário delete a edge facilmente.
 */

import { memo } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  useReactFlow,
} from '@xyflow/react';
import { IconX } from '@tabler/icons-react';

import './DeletableEdge.css';

const DeletableEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}) => {
  const { setEdges } = useReactFlow();

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onEdgeClick = (evt) => {
    evt.stopPropagation();
    setEdges((edges) => edges.filter((edge) => edge.id !== id));
  };

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: selected ? 3 : 2,
        }}
      />
      <EdgeLabelRenderer>
        <div
          className={`deletable-edge-button ${selected ? 'visible' : ''}`}
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
        >
          <button
            className="deletable-edge-delete-btn"
            onClick={onEdgeClick}
            title="Remover conexão"
          >
            <IconX size={12} stroke={2.5} />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default memo(DeletableEdge);
